import { DecoratorResult } from "../types";
export function styleDecorator(productOption, style, skin) {
    const result = new DecoratorResult();
    if (productOption.style !== style) {
        result.addMutation({
            type: "add",
            reason: "style was undefined, setting to default style",
            oldState: productOption.style,
            newState: style,
        });
        productOption.style = style;
    }
    return result;
}
//# sourceMappingURL=style-decorator.js.map